// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tilte-collection{
    font-size: 25px;
    font-weight: 500;
}


.collection-table-head{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    background-color: #0059B2;
    color: #FFFFFF;
    padding: 20px 10px;
    /* border-radius: 10px; */
    margin: 0px 20px;
    position: sticky;
    top: 0;
     z-index: 1;
 }

 .collection-table-body{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    /* background-color: #0059B2; */
    color: black;
    border: 1px solid grey;
    padding: 20px 10px;
    /* border-radius: 10px; */
    margin: 0px 20px;
 }

 .summary-table .css-yrdy0g-MuiDataGrid-columnHeaderRow{
     color: #FFFFFF;
     background-color: #1F2BAB;
    
 }

 .summary-table .css-t89xny-MuiDataGrid-columnHeaderTitle{
    font-weight: 800 !important ;
    text-align: center;
 }

 .summary-table .MuiDataGrid-columnHeaderTitleContainer{
    justify-content: center;
 }

 .summary-table .css-c5c7cs-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell{
    /* word-wrap: break-word; */
    white-space: break-spaces;
    padding: 20px;
    text-align: center;
 }


 .summary-table .MuiDataGrid-cell{
    padding: 10px !important;
 }

 .search-div-colection {
    margin-left: 10px;
 }

 .search-div-colection .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{
    margin-top: 0px !important;
 }

 .div-daterange>div{
    padding-top: 0px !important;
 }


 .date-part-collection{
   display: flex;
   flex-direction: column;
   background-color: #dcdcdc;
   /* border: 1px solid green; */
   border-radius: 5px;
   color: black;
   padding: 2px 5px;
 }

 .summary-table .MuiDataGrid-footer {
   -webkit-user-select: none;
           user-select: none;
 }


 .summary-table .MuiDataGrid-row{
   cursor: pointer;
 }`, "",{"version":3,"sources":["webpack://./src/components/Collection/Collection.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;KACL,UAAU;CACd;;CAEA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;CACnB;;CAEA;KACI,cAAc;KACd,yBAAyB;;CAE7B;;CAEA;IACG,4BAA4B;IAC5B,kBAAkB;CACrB;;CAEA;IACG,uBAAuB;CAC1B;;CAEA;IACG,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,kBAAkB;CACrB;;;CAGA;IACG,wBAAwB;CAC3B;;CAEA;IACG,iBAAiB;CACpB;;CAEA;IACG,0BAA0B;CAC7B;;CAEA;IACG,2BAA2B;CAC9B;;;CAGA;GACE,aAAa;GACb,sBAAsB;GACtB,yBAAyB;GACzB,6BAA6B;GAC7B,kBAAkB;GAClB,YAAY;GACZ,gBAAgB;CAClB;;CAEA;GACE,yBAAiB;WAAjB,iBAAiB;CACnB;;;CAGA;GACE,eAAe;CACjB","sourcesContent":[".tilte-collection{\n    font-size: 25px;\n    font-weight: 500;\n}\n\n\n.collection-table-head{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    background-color: #0059B2;\n    color: #FFFFFF;\n    padding: 20px 10px;\n    /* border-radius: 10px; */\n    margin: 0px 20px;\n    position: sticky;\n    top: 0;\n     z-index: 1;\n }\n\n .collection-table-body{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    /* background-color: #0059B2; */\n    color: black;\n    border: 1px solid grey;\n    padding: 20px 10px;\n    /* border-radius: 10px; */\n    margin: 0px 20px;\n }\n\n .summary-table .css-yrdy0g-MuiDataGrid-columnHeaderRow{\n     color: #FFFFFF;\n     background-color: #1F2BAB;\n    \n }\n\n .summary-table .css-t89xny-MuiDataGrid-columnHeaderTitle{\n    font-weight: 800 !important ;\n    text-align: center;\n }\n\n .summary-table .MuiDataGrid-columnHeaderTitleContainer{\n    justify-content: center;\n }\n\n .summary-table .css-c5c7cs-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell{\n    /* word-wrap: break-word; */\n    white-space: break-spaces;\n    padding: 20px;\n    text-align: center;\n }\n\n\n .summary-table .MuiDataGrid-cell{\n    padding: 10px !important;\n }\n\n .search-div-colection {\n    margin-left: 10px;\n }\n\n .search-div-colection .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{\n    margin-top: 0px !important;\n }\n\n .div-daterange>div{\n    padding-top: 0px !important;\n }\n\n\n .date-part-collection{\n   display: flex;\n   flex-direction: column;\n   background-color: #dcdcdc;\n   /* border: 1px solid green; */\n   border-radius: 5px;\n   color: black;\n   padding: 2px 5px;\n }\n\n .summary-table .MuiDataGrid-footer {\n   user-select: none;\n }\n\n\n .summary-table .MuiDataGrid-row{\n   cursor: pointer;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
